import * as types from "./ac_actionTypes";
import * as HeaderAuthentication from '../../HeaderAuthentication'
import { baseURL } from "../../BaseURL";
import { toast } from "react-toastify";

let headerAuth = HeaderAuthentication.getRequestOptions;
const signInDetails = JSON.parse(sessionStorage.getItem("SignInDetails"));

// region to store the data
export const getCurrentPlan = (currentPlan) => ({
    type: types.get_current_plan,
    payload: currentPlan,
});
export const getCreditUsage = (creditUsage) => ({
    type: types.get_credit_usage,
    payload: creditUsage,
});
// endregion

// region api calling
// region load current plan
export const loadCurrentPlan = (planName, cycle) => {
    return function (dispatch) {
        return fetch(`${baseURL}/Users/get_current_plan?plan_name=${planName}&billing_cycle=${cycle}`, headerAuth)
            .then((resp) => resp.json())
            .then((resp) => {
                console.log(resp)
                if (resp.status_code === 200) {
                    dispatch(getCurrentPlan(resp.data))
                }
                return resp
            })
            .catch((err) => { console.log(err) });
    }
}
// endregion

// region load credit usage
export const loadCreditUsage = () => {
    return function (dispatch) {
        return fetch(`${baseURL}/Users/get_credit_usage?sbn_id=${signInDetails[0]?.sbn_id}`, headerAuth)
            .then((resp) => resp.json())
            .then((resp) => {
                console.log(resp)
                if (resp.status_code === 200) {
                    dispatch(getCreditUsage(resp.data))
                }
                return resp
            })
            .catch((err) => { console.log(err) });
    }
}
// endregion
// endregion